import { inter } from "@/lib/fonts/inter";
import { notoSerif } from "@/lib/fonts/notoSerif";

/** Merge on the same node as `.app-shell-fonts` so `globals.css` can use both CSS variables. */
const appShellFontVariablesClassName = `${inter.variable} ${notoSerif.variable}`.trim();

export { inter, notoSerif, appShellFontVariablesClassName };
